<app-configuration-page
  title="Payment Methods"
  description="Choose which payment methods your studio offers, and drag to set the order staff see. Hidden methods no longer appear when entering new payments. Existing payments, reports, and imports are not affected."
  [breadcrumbs]="[{ label: 'Payment Methods' }]">

  <!-- The card title would just restate the page title; only the ordering
       note below adds anything, so it moves into the page description. -->
  <mat-card class="configuration-card">
    <mat-card-content>
      <app-payment-methods-form></app-payment-methods-form>
    </mat-card-content>
  </mat-card>

</app-configuration-page>
